import React from "react";
import {IonItem} from "@ionic/react";

/**
 *
 * @author Alizée Grand
 * @version 1.0
 * @creation 18/05/2022
 * @last_update 18/05/2022
 **/
class ValidationItem extends React.Component<{
    label: string,
    children: React.ReactNode
}> {

    render() {

        return (
            <IonItem>
                <div>
                    <h1 className="accent-word">{this.props.label} :</h1>
                    {this.props.children}
                </div>
            </IonItem>
        );

    };

}

export default ValidationItem;
